module.exports = __webpack_public_path__ + "static/media/sales-landscape.236e607d.jpg";